// import React from 'react'
// import {
//   ArrowDown,
//   ArrowUp,
//   Wallet,
//   CheckCircle,
//   Clock,
//   Briefcase,
//   Activity,
//   TrendingUp,
//   PieChart,
//   Building2,
//   Users,
//   Banknote,
//   Zap,
//   Target,
//   IndianRupee,
//   FileText,
// } from 'lucide-react'

// const FinancialDashboard = () => {
//   // --- 1. DATA CONFIGURATION ---

//   // A. Income Sources
//   const incomeSources = [
//     {
//       id: 1,
//       name: 'Fees',
//       amount: 100,
//       icon: <Briefcase size={18} />,
//       color: 'text-blue-600',
//       bg: 'bg-blue-50',
//       border: 'border-blue-100',
//     },
//     {
//       id: 2,
//       name: 'Software',
//       amount: 700,
//       icon: <Activity size={18} />,
//       color: 'text-purple-600',
//       bg: 'bg-purple-50',
//       border: 'border-purple-100',
//     },
//     {
//       id: 3,
//       name: 'Other',
//       amount: 200,
//       icon: <TrendingUp size={18} />,
//       color: 'text-emerald-600',
//       bg: 'bg-emerald-50',
//       border: 'border-emerald-100',
//     },
//     {
//       id: 4,
//       name: 'Invest',
//       amount: 100,
//       icon: <PieChart size={18} />,
//       color: 'text-orange-600',
//       bg: 'bg-orange-50',
//       border: 'border-orange-100',
//     },
//     {
//       id: 5,
//       name: 'Electronics',
//       amount: 100,
//       icon: <Zap size={18} />,
//       color: 'text-cyan-600',
//       bg: 'bg-cyan-50',
//       border: 'border-cyan-100',
//     },
//   ]

//   // B. Expenses Data
//   const expensesList = [
//     { id: 1, name: 'Company', amount: 100 },
//     { id: 2, name: 'Salary', amount: 100 },
//     { id: 3, name: 'Supplies', amount: 100 },
//   ]

//   // C. Calculations
//   const totalIncome = incomeSources.reduce((acc, item) => acc + item.amount, 0) // 1200
//   const totalRequestedExpense = expensesList.reduce(
//     (acc, item) => acc + item.amount,
//     0,
//   ) // 300

//   // D. Logic
//   const approvedExpense = 200
//   const pendingExpense = totalRequestedExpense - approvedExpense // 100
//   const finalBalance = totalIncome - approvedExpense // 1000

//   // E. Assets
//   const assets = [
//     {
//       name: 'Current A/C',
//       amount: 300,
//       icon: <Building2 size={20} />,
//       color: 'text-indigo-600',
//       bg: 'bg-indigo-50',
//     },
//     {
//       name: 'Joint A/C',
//       amount: 100,
//       icon: <Users size={20} />,
//       color: 'text-pink-600',
//       bg: 'bg-pink-50',
//     },
//     {
//       name: 'Cash In Hand',
//       amount: 600,
//       icon: <Banknote size={20} />,
//       color: 'text-teal-600',
//       bg: 'bg-teal-50',
//     },
//   ]

//   // F. Summary Cards Data
//   const summaryCards = [
//     {
//       title: 'Total Revenue',
//       amount: totalIncome,
//       icon: <Wallet className='text-white' size={20} />,
//       gradient: 'from-blue-500 to-blue-600',
//       textColor: 'text-blue-700',
//       subtext: 'All Income',
//     },
//     {
//       title: 'Total Expenses',
//       amount: totalRequestedExpense,
//       icon: <FileText className='text-white' size={20} />,
//       gradient: 'from-violet-500 to-purple-600',
//       textColor: 'text-purple-700',
//       subtext: 'Requested Pool',
//     },
//     {
//       title: 'Approved',
//       amount: approvedExpense,
//       icon: <CheckCircle className='text-white' size={20} />,
//       gradient: 'from-red-500 to-red-600',
//       textColor: 'text-red-700',
//       subtext: 'Deducted',
//     },
//     {
//       title: 'Pending',
//       amount: pendingExpense,
//       icon: <Clock className='text-white' size={20} />,
//       gradient: 'from-amber-400 to-orange-500',
//       textColor: 'text-orange-700',
//       subtext: 'In Review',
//     },
//     {
//       title: 'Net Balance',
//       amount: finalBalance,
//       icon: <Target className='text-white' size={20} />,
//       gradient: 'from-emerald-500 to-green-600',
//       textColor: 'text-green-700',
//       subtext: 'Available',
//     },
//   ]

//   return (
//     <div className='min-h-screen bg-slate-100 p-4 md:p-6 font-sans text-slate-800'>
//       <div className='max-w-[1400px] mx-auto space-y-6'>
//         {/* HEADER */}
//         <div className='flex justify-between items-center mb-2'>
//           <div>
//             <h1 className='text-2xl font-extrabold text-slate-800'>
//               Financial Overview
//             </h1>
//             <p className='text-sm text-slate-500'>
//               System Status:{' '}
//               <span className='text-green-600 font-semibold'>Live</span>
//             </p>
//           </div>
//           <div className='hidden md:block text-right'>
//             <p className='text-xs text-slate-400'>Last Updated</p>
//             <p className='text-sm font-semibold'>Just Now</p>
//           </div>
//         </div>

//         {/* --- SECTION 1: TOP SUMMARY CARDS --- */}
//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4'>
//           {summaryCards.map((card, idx) => (
//             <div
//               key={idx}
//               className='bg-white rounded-xl p-4 shadow-sm border border-slate-200 relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300'
//             >
//               <div className='flex justify-between items-start mb-4'>
//                 <div>
//                   <p className='text-xs font-semibold text-slate-400 uppercase tracking-wider'>
//                     {card.title}
//                   </p>
//                   {/* Fixed Rupee Alignment Here */}
//                   <h2
//                     className={`text-2xl xl:text-3xl font-bold mt-1 ${card.textColor} flex items-center`}
//                   >
//                     <IndianRupee size={24} strokeWidth={2.5} />
//                     {card.amount}
//                   </h2>
//                 </div>
//                 <div
//                   className={`p-3 rounded-lg shadow-md bg-gradient-to-br ${card.gradient}`}
//                 >
//                   {card.icon}
//                 </div>
//               </div>
//               <div className='flex items-center gap-1 text-xs text-slate-400'>
//                 {idx === 0 || idx === 4 ? (
//                   <ArrowUp size={12} className='text-green-500' />
//                 ) : (
//                   <ArrowDown size={12} className='text-slate-500' />
//                 )}
//                 <span>{card.subtext}</span>
//               </div>
//               <div
//                 className={`absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r ${card.gradient} opacity-20`}
//               ></div>
//             </div>
//           ))}
//         </div>

//         {/* --- SECTION 2: INCOMING SOURCES BREAKDOWN --- */}
//         <div className='bg-white rounded-xl shadow-sm border border-slate-200 p-5'>
//           <h3 className='text-sm font-bold text-slate-700 mb-4 flex items-center gap-2'>
//             <div className='bg-blue-100 p-1 rounded'>
//               <ArrowDown size={16} className='text-blue-600' />
//             </div>
//             Incoming Sources Breakdown
//           </h3>
//           <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4'>
//             {incomeSources.map((source) => (
//               <div
//                 key={source.id}
//                 className={`p-4 rounded-xl border ${source.border} ${source.bg} flex flex-col items-center justify-center text-center transition-all hover:shadow-md cursor-default`}
//               >
//                 <div
//                   className={`mb-2 ${source.color} bg-white p-2 rounded-full shadow-sm`}
//                 >
//                   {source.icon}
//                 </div>
//                 <span className='text-xs font-semibold text-slate-500 uppercase'>
//                   {source.name}
//                 </span>
//                 {/* Fixed Rupee Alignment Here */}
//                 <span
//                   className={`text-lg font-bold ${source.color} flex items-center gap-0.5`}
//                 >
//                   <IndianRupee size={16} strokeWidth={3} />
//                   {source.amount}
//                 </span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* --- SECTION 3: EXPENSE & ASSETS SPLIT VIEW --- */}
//         <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
//           {/* LEFT: EXPENSE MANAGEMENT */}
//           <div className='bg-white rounded-xl shadow-sm border border-slate-200 p-6 flex flex-col'>
//             <div className='flex justify-between items-center mb-6'>
//               <h3 className='font-bold text-slate-800 flex items-center gap-2'>
//                 <Activity size={18} className='text-slate-400' /> Expense Status
//               </h3>
//               <span className='text-xs bg-slate-100 text-slate-500 px-2 py-1 rounded'>
//                 Requests: {expensesList.length}
//               </span>
//             </div>

//             {/* Status Bars */}
//             <div className='space-y-4 flex-1'>
//               {/* Approved Card */}
//               <div className='p-4 rounded-xl border border-red-100 bg-red-50/50 flex items-center justify-between group hover:bg-red-50 transition-colors'>
//                 <div className='flex items-center gap-3'>
//                   <div className='bg-white p-2 rounded-lg border border-red-100 text-red-500'>
//                     <CheckCircle size={20} />
//                   </div>
//                   <div>
//                     <p className='text-sm font-bold text-slate-700'>Approved</p>
//                     <p className='text-xs text-red-400'>Confirmed Deductions</p>
//                   </div>
//                 </div>
//                 <div className='text-right'>
//                   {/* Fixed Rupee Alignment Here */}
//                   <span className='flex items-center justify-end text-xl font-bold text-slate-800'>
//                     - <IndianRupee size={18} strokeWidth={2.5} />{' '}
//                     {approvedExpense}
//                   </span>
//                   <span className='text-xs text-slate-400'>Processed</span>
//                 </div>
//               </div>

//               {/* Pending Card */}
//               <div className='p-4 rounded-xl border border-orange-200 bg-orange-50 border-dashed flex items-center justify-between opacity-90'>
//                 <div className='flex items-center gap-3'>
//                   <div className='bg-white p-2 rounded-lg border border-orange-100 text-orange-500'>
//                     <Clock size={20} />
//                   </div>
//                   <div>
//                     <p className='text-sm font-bold text-slate-700'>Pending</p>
//                     <p className='text-xs text-orange-400'>Awaiting Approval</p>
//                   </div>
//                 </div>
//                 <div className='text-right'>
//                   {/* Fixed Rupee Alignment Here */}
//                   <span className='flex items-center justify-end text-xl font-bold text-slate-800'>
//                     <IndianRupee size={18} strokeWidth={2.5} /> {pendingExpense}
//                   </span>
//                   <span className='text-xs text-orange-500'>On Hold</span>
//                 </div>
//               </div>
//             </div>

//             {/* Mini Breakdown */}
//             <div className='mt-6 pt-4 border-t border-slate-100'>
//               <p className='text-xs font-semibold text-slate-400 mb-2 uppercase'>
//                 Recent Requests
//               </p>
//               <div className='flex gap-2 overflow-x-auto pb-2'>
//                 {expensesList.map((exp) => (
//                   <span
//                     key={exp.id}
//                     className='text-xs px-2 py-1 bg-slate-100 text-slate-600 rounded whitespace-nowrap flex items-center gap-1'
//                   >
//                     {exp.name}
//                     <span className='font-bold flex items-center'>
//                       <IndianRupee size={10} />
//                       {exp.amount}
//                     </span>
//                   </span>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT: ASSETS */}
//           <div className='bg-white rounded-xl shadow-sm border border-slate-200 p-6 flex flex-col'>
//             <div className='flex justify-between items-center mb-6'>
//               <h3 className='font-bold text-slate-800 flex items-center gap-2'>
//                 <Banknote size={18} className='text-slate-400' /> Asset
//                 Allocation
//               </h3>
//               <div className='text-right'>
//                 <span className='block text-xs text-slate-400'>
//                   Total Net Balance
//                 </span>
//                 {/* Fixed Rupee Alignment Here */}
//                 <span className='flex items-center justify-end text-sm font-bold text-green-600'>
//                   <IndianRupee size={14} /> {finalBalance}
//                 </span>
//               </div>
//             </div>

//             <div className='space-y-3 flex-1'>
//               {assets.map((asset, idx) => (
//                 <div
//                   key={idx}
//                   className='flex items-center justify-between p-3 rounded-xl border border-slate-100 hover:border-slate-300 hover:shadow-sm transition-all bg-white'
//                 >
//                   <div className='flex items-center gap-3'>
//                     <div
//                       className={`p-2 rounded-lg ${asset.bg} ${asset.color}`}
//                     >
//                       {asset.icon}
//                     </div>
//                     <span className='text-sm font-semibold text-slate-700'>
//                       {asset.name}
//                     </span>
//                   </div>
//                   <div className='text-right'>
//                     {/* Fixed Rupee Alignment Here */}
//                     <span className='flex items-center justify-end text-lg font-bold text-slate-800'>
//                       <IndianRupee size={18} strokeWidth={2.5} /> {asset.amount}
//                     </span>
//                     <div className='w-20 h-1 bg-slate-100 rounded-full mt-1 overflow-hidden ml-auto'>
//                       <div
//                         className={`h-full ${asset.color.replace('text-', 'bg-')}`}
//                         style={{
//                           width: `${(asset.amount / finalBalance) * 100}%`,
//                         }}
//                       ></div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default FinancialDashboard
import React from 'react'

const page = () => {
  return (
    <div className='min-h-screen flex items-center justify-center'>
      <p className='text-lg font-medium text-slate-600'>coming soon......</p>
    </div>
  )
}
export default page
